import { DialogHelper } from "../core/util/dialogHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Grid } from "../core/components/grid.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { ResourcePlanningSchedulerEventViewModel } from "./resourcePlanningScheduler.js";
import { Config } from "../core/config/config.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { OpenEventInfoDialog, ScheduleEventToBeDeletedViewModel } from "./dialogs/eventInfoDialog.js";
import {
    DeletingExecutionAssignmentPreviewEntity, OpenResourcePlanningDeletionDialog
} from "../resourcePlanningDialogs/resourcePlanningDeletionDialog.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";

export class MultiselectHelper {

    private static translations: StringKeyDictionary<string> = null;

    public static MoveToRessource = async (events: ResourcePlanningSchedulerEventViewModel[], ressNr: string) => {
        if (Helper.isNullOrEmpty(ressNr))
            return;
        await MultiselectHelper.loadTranslations();
        const result = await HTTPService.post<JsonResultClass<MultiselectActionInfo[]>>('ResourcePlanningScheduler/ExecuteMultiSelectAction', {
            msAction: MultiSelectAction.MoveToResource,
            ids: events.map((event) => { return event.IsGuid; }),
            additionalSettings: {
                "ressNr": ressNr
            }
        });
        if (result.Code == 0) {
            if (Helper.hasValue(result.AdditionalData)) {
                if (result.AdditionalData.showSkillsWarning) {
                    NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.SkillsWasntconsidered"));
                }
            }


        }
        return await MultiselectHelper.HandleHttpResult(events, result);
    }

    public static Delete = async (events: Array<ResourcePlanningSchedulerEventViewModel>) => {

        if (events.length == 1) {
            let entity = {
                ...events[0],
                ProjNr: events[0].Projnr,
                PIndex: events[0].Pindex,
                KNr: events[0].KNr
            };
            await OpenResourcePlanningDeletionDialog(entity, () => { });
            return;
        }

        await MultiselectHelper.loadTranslations();

        let eventsToBeDeleted: ScheduleEventToBeDeletedViewModel[] = [];

        for (let event of events) {
            let cycleLink = await HTTPService.get<JsonResultClass<DeletingExecutionAssignmentPreviewEntity>>(
                'ResourcePlanning/GetDeletingExecutionAssignmentPreview?projNr=' + encodeURIComponent(event.Projnr) + '&pIndex=' + event.Pindex + '&lockCycle=false');
            let eventToBeDeleted: ScheduleEventToBeDeletedViewModel = { ...event, IsDeletable: true };
            eventsToBeDeleted.push(eventToBeDeleted);
            if (cycleLink.Code == 0 && cycleLink.Data.Preview.TaskExecutionInfo != null) {
                eventToBeDeleted.Preview = cycleLink.Data.Preview;
                eventToBeDeleted.IsDeletable = false;
            }
        }

        const isOk = await OpenEventInfoDialog(eventsToBeDeleted, Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Multiselect.QuestionDeleteSelectedAssignments"));
        if (!isOk)
            return;
        const result = await HTTPService.post<JsonResultClass<MultiselectActionInfo[]>>('ResourcePlanningScheduler/ExecuteMultiSelectAction', {
            msAction: MultiSelectAction.Delete,
            ids: eventsToBeDeleted.filter(e => e.IsDeletable).map((event) => { return event.IsGuid; })
        });
        return await MultiselectHelper.HandleHttpResult(events, result);
    }

    public static MoveToContainer = async (events: ResourcePlanningSchedulerEventViewModel[]) => {
        await MultiselectHelper.loadTranslations();

        const isOk = await DialogHelper.confirm(MultiselectHelper.translations["WebSMS.ResourcePlanningScheduler.Multiselect.MoveToContainer"]);
        if (!isOk)
            return;

        const result = await HTTPService.post<JsonResultClass<MultiselectActionInfo[]>>('ResourcePlanningScheduler/ExecuteMultiSelectAction', {
            msAction: MultiSelectAction.MoveToContainer,
            ids: events.map((event) => { return event.IsGuid; })
        });
        return await MultiselectHelper.HandleHttpResult(events, result);
    }

    public static FixEvents = async (events: ResourcePlanningSchedulerEventViewModel[], fixMode: FixMode) => {
        await MultiselectHelper.loadTranslations();

        const isOk = await DialogHelper.confirm(MultiselectHelper.translations["WebSMS.ResourcePlanningScheduler.Multiselect.Fix"]);
        if (!isOk)
            return;
        const result = await HTTPService.post<JsonResultClass<MultiselectActionInfo[]>>('ResourcePlanningScheduler/ExecuteMultiSelectAction', {
            msAction: MultiSelectAction.Fix,
            ids: events.map((event) => { return event.IsGuid; }),
            additionalSettings: {
                fixMode: fixMode
            }
        });
        return await MultiselectHelper.HandleHttpResult(events, result);
    }

    public static DeFixEvents = async (events: ResourcePlanningSchedulerEventViewModel[], fixMode: FixMode) => {
        await MultiselectHelper.loadTranslations();

        const isOk = await DialogHelper.confirm(MultiselectHelper.translations["WebSMS.ResourcePlanningScheduler.Multiselect.Defix"]);
        if (!isOk)
            return;
        const result = await HTTPService.post<JsonResultClass<MultiselectActionInfo[]>>('ResourcePlanningScheduler/ExecuteMultiSelectAction', {
            msAction: MultiSelectAction.DeFix,
            ids: events.map((event) => { return event.IsGuid; }),
            additionalSettings: {
                fixMode: fixMode
            }
        });
        return await MultiselectHelper.HandleHttpResult(events, result);
    }

    public static HandleHttpResult = async (events: ResourcePlanningSchedulerEventViewModel[], result: JsonResultClass<MultiselectActionInfo[]>) => {
        switch (result.Code) {
            case 0:
                NotificationHelper.showSuccessMessage(result.Message)
                break;
            case 1:
                let data = result.Data.filter(f => f.Code == 1).map((value) => {
                    const event = events.find(f => f.IsGuid == value.Id);
                    return $.extend(value, event);
                })
                await MultiselectHelper.openErrorDialog(data)
                break;
            case 2:
                NotificationHelper.showErrorMessage(result.Message)
                break;
        }
        return result.Data.filter(f => f.Code == 0).map((value) => { return value.Id; });
    }

    public static OpenRessourceSearch = (events: ResourcePlanningSchedulerEventViewModel[]) => {
        return new Promise<string>((resolve) => {
            let url = "DynamicSearch/Window/Resource?withSkills=true&cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true&resstatus=0%20or%20null&disabled=resstatus";
            if (events.length > 0)
                url += "&" + Helper.createQueryStringParameters("eventIsGuids", events.map(x => x.IsGuid));
            const sheet = General.Sheet.Manager.createSheetWithUrl(url);
            sheet.bind(SheetEventType.RowClicked, async (ressNr: string) => {
                resolve(ressNr)
            });
        })
    }

    private static loadTranslations = async () => {
        if (MultiselectHelper.translations == null) {
            MultiselectHelper.translations = (await Helper.getTranslations(["WebSMS.ResourcePlanningScheduler.Multiselect.QuestionDeleteSelectedAssignments",
                "WebSMS.ResourcePlanningScheduler.Multiselect.ActionFailedForAssignments", "Field.Einsatz.projnr", "Field.Einsatz.Bemerkung", "Field.Ressource.name", "Field.Adresse.adrname",
                "Field.Einsatz.startist", "Field.Einsatz.endeist", "WebSMS.ResourcePlanningScheduler.Multiselect.ErrorMessage", "WebSMS.ResourcePlanningScheduler.Multiselect.MoveToContainer",
                "WebSMS.ResourcePlanningScheduler.Multiselect.Fix", "WebSMS.ResourcePlanningScheduler.Multiselect.Defix"])).Data;
        }
    }

    private static openErrorDialog = async (infos: MultiselectActionInfo[]) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);

        const dialogProps: DialogProps = {
            title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Multiselect.ActionFailedForAssignments"),
            actions: [
                {
                    label: Config.translations.ok,
                    action: () => {
                        return;
                    },
                    primary: true
                }
            ],
            width: 1081,
            afterClose: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
        };
        const dialog = (
            <Dialog {...dialogProps} open={true}>
                {MultiselectHelper.createErrorGrid(infos)}
            </Dialog>
        )
        ReactDOM.render(dialog, targetElement[0]);
    }

    private static createErrorGrid = (infos: MultiselectActionInfo[]) => {
        const gridOptions: kendo.ui.GridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: false,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    title: Helper.getTranslation("Field.Einsatz.projnr"),
                    field: "ProjNr",
                    template: `#let url = '${Config.baseUrl}ResourcePlanning/Edit?projnr=' + data.ProjNr + '&pindex=' + data.PIndex;#<a target="_blank" href="#=url#">#=data.ProjNr#/#=data.PIndex#</a>`,
                    width: 120

                },
                {
                    title: Helper.getTranslation("Field.Einsatz.Bemerkung"),
                    field: "Title"
                },
                {
                    title: Helper.getTranslation("Field.Ressource.name"),
                    field: "ResourceName",
                    template: "#let text = data.ResourceName;let arr = data.ResourceId.split('|');text += ' (' + arr[1] + ')';#<div>#=text#</div>"
                },
                {
                    title: Helper.getTranslation("Field.Adresse.adrname"),
                    field: "AdrName"
                },
                {
                    title: Helper.getTranslation("Field.Einsatz.startist"),
                    field: "Start",
                    template: "#= kendo.toString(kendo.parseDate(Start), 'G') #",
                    width: 120
                },
                {
                    title: Helper.getTranslation("Field.Einsatz.endeist"),
                    field: "End",
                    template: "#= kendo.toString(kendo.parseDate(End), 'G') #",
                    width: 120
                },
                {
                    title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Multiselect.ErrorMessage"),
                    field: "Message"
                }

            ]
        };
        return (
            <div className="flex-container">
                <Grid
                    data={infos}
                    options={gridOptions}
                    id="resourcePlanningScheduler_ErrorsGrid"
                />
            </div>
        );
    }
}


export enum MultiSelectAction {
    Delete = 0,
    New = 1,
    Change = 2,
    ChangeLast = 3,
    MoveToResource = 4,
    MoveToContainer = 5,
    Fix = 6,
    DeFix = 7,
    FilterProjects = 8
}

export enum FixMode {
    None = 0,
    Start = 1 << 0,     // 0001
    End = 1 << 1,       // 0010
    Ressource = 1 << 2  // 0100
}

export interface MultiselectActionInfo {
    Code: number;
    Message: string;
    ProjNr: string;
    PIndex: number;
    Id: string;
}